import { render, staticRenderFns } from "./VideoArea.vue?vue&type=template&id=196c0a88&scoped=true&"
import script from "./VideoArea.vue?vue&type=script&lang=js&"
export * from "./VideoArea.vue?vue&type=script&lang=js&"
import style0 from "./VideoArea.vue?vue&type=style&index=0&id=196c0a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c0a88",
  null
  
)

export default component.exports